import {
  CLEAR_USER,
  RECEIVE_USER,
  RECEIVE_USER_COMPANIES,
  RECEIVE_USER_FAIL,
  REQUEST_USER,
  REQUEST_USER_COMPANIES,
  UPDATE_USER_DIAL_CODE,
} from '../actions';
import piwikTracker from '../utils/piwik';

const defaultState = {
  isFetching: false,
  errorMessage: '',
  errorCode: '',
  dialCode: '',
  token: '',
  user: {},
  companies: [],
  isFetchingCompanies: false,
};

export function users(state = defaultState, action = null) {
  switch (action.type) {
    case CLEAR_USER: {
      return defaultState;
    }
    case UPDATE_USER_DIAL_CODE: {
      return { ...state, dialCode: action.dialCode };
    }
    case REQUEST_USER: {
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      };
    }
    case RECEIVE_USER: {
      piwikTracker.setUserId(String(action.user.id));
      return {
        ...state,
        isFetching: false,
        errorMessage: '',
        token: action.token,
        user: action.user,
      };
    }
    case RECEIVE_USER_FAIL: {
      return {
        ...state,
        isFetching: false,
        errorMessage: action.errorMessage,
        errorCode: action.errorCode,
      };
    }
    case REQUEST_USER_COMPANIES: {
      return { ...state, isFetchingCompanies: true };
    }
    case RECEIVE_USER_COMPANIES: {
      return {
        ...state,
        companies: action.companies,
        isFetchingCompanies: false,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/users.js